const isDayType = (x: any): boolean => typeof x === 'number' && x >= 1 && x <= 31;
export default isDayType;
